import React, { useEffect, useState } from "react";
import { Trophy, Users, GraduationCap, School } from "lucide-react";
import { StudentShell } from "../components/StudentShell";
import { useLang } from "../i18n";
import { api, useAuth } from "../api";

const SCOPES = [
  { key: "class", label: "صفّي", icon: Users },
  { key: "grade", label: "طبقتي", icon: GraduationCap },
  { key: "school", label: "مدرستي", icon: School },
];

export default function Leaderboard() {
  const { t } = useLang();
  const { user } = useAuth();
  const [scope, setScope] = useState("class");
  const [data, setData] = useState({ rows: [], allowed: ["class"] });
  const [comps, setComps] = useState([]);

  useEffect(() => { api.get("/competitions").then((r) => setComps(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    api.get("/leaderboard/scoped", { params: { scope } })
      .then((r) => setData(r.data))
      .catch((e) => {
        if (e?.response?.status === 403) setScope("class");
      });
  }, [scope]);

  const medal = (i) => ["🥇", "🥈", "🥉"][i] || `${i + 1}`;

  return (
    <StudentShell>
      <h1 className="text-4xl font-black text-white glow-text flex items-center gap-3">
        <Trophy size={30} />{t("leaderboard")}</h1>
      <p className="text-white/70 mt-2 text-sm">
        ترتيب الطلاب بالنقاط — {user?.school_name} · {t("grade")} {user?.grade}</p>

      <div className="flex gap-2 mt-6 flex-wrap" data-testid="scope-tabs">
        {SCOPES.filter((s) => (data.allowed || []).includes(s.key)).map(({ key, label, icon: Icon }) => (
          <button key={key} data-testid={`scope-${key}`} onClick={() => setScope(key)}
            className="play-btn text-white text-sm flex items-center gap-2"
            style={{ background: scope === key ? "var(--play-primary)" : "rgba(255,255,255,.12)" }}>
            <Icon size={15} />{label}</button>
        ))}
      </div>

      <div className="play-card mt-6" style={{ borderColor: "var(--play-secondary)" }}
        data-testid="students-leaderboard">
        {(data.rows || []).map((s, i) => (
          <div key={i} data-testid={`lb-row-${i}`}
            className="flex items-center gap-3 py-3 border-b border-white/10 rounded-xl px-2"
            style={s.is_me ? { background: "rgba(255,180,63,.12)" } : {}}>
            <span className="w-8 text-lg font-black">{medal(i)}</span>
            <div className="flex-1">
              <div className="font-bold">{s.name}{s.is_me && " (أنت)"}</div>
              <div className="text-xs text-white/50">
                {t("grade")} {s.grade || "-"}{s.class_name !== "-" ? ` · ${s.class_name}` : ""}</div>
            </div>
            <span className="font-black" style={{ color: "var(--play-primary)" }}>{s.points}</span>
          </div>
        ))}
        {!(data.rows || []).length && <p className="text-white/45">{t("noData")}</p>}
      </div>

      {!!comps.length && (
        <div className="play-card mt-6" style={{ borderColor: "var(--play-accent)" }} data-testid="active-comps">
          <h2 className="text-xl font-black">{t("competitions")}</h2>
          <div className="mt-3 space-y-2">
            {comps.map((c) => (
              <div key={c.id} className="flex justify-between text-sm border-b border-white/10 pb-2"
                data-testid={`comp-${c.id}`}>
                <b>{c.title}</b>
                <span className="text-white/60">{t("grade")} {c.grade}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </StudentShell>
  );
}
